"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepperStep = void 0;
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
const classnames_1 = __importDefault(require("classnames"));
const React = __importStar(require("react"));
const index_js_1 = require("../Tooltip/index.js");
const StepperStep = (props) => {
    const { title, index, currentStepNumber, totalSteps, type, onClick, description, className, style, ...rest } = props;
    const isPast = currentStepNumber > index;
    const isActive = currentStepNumber === index;
    const isClickable = isPast && !!onClick;
    const onCompletedClick = () => {
        if (isClickable) {
            onClick === null || onClick === void 0 ? void 0 : onClick(index);
        }
    };
    const onKeyDown = (e) => {
        if (e.altKey) {
            return;
        }
        if (!isClickable) {
            return;
        }
        if (e.key === 'Enter' || e.key === 'Space' || e.key === ' ') {
            onCompletedClick();
        }
    };
    const stepShape = (React.createElement("li", { className: (0, classnames_1.default)('iui-stepper-step', {
            'iui-current': isActive,
            'iui-clickable': isClickable,
        }, className), style: {
            width: type === 'default' ? `${100 / totalSteps}%` : undefined,
            ...style,
        }, onClick: onCompletedClick, onKeyDown: onKeyDown, "aria-current": isActive ? 'step' : undefined, tabIndex: isClickable ? 0 : undefined, ...rest },
        React.createElement("div", { className: 'iui-stepper-track-content' },
            React.createElement("span", { className: 'iui-stepper-circle' }, index + 1)),
        type === 'default' && (React.createElement("span", { className: 'iui-stepper-step-name' }, title))));
    return description ? (React.createElement(index_js_1.Tooltip, { content: description }, stepShape)) : (stepShape);
};
exports.StepperStep = StepperStep;
